// @flow

import { startRequest, finishRequest } from "@store/utils";
import type { NotificationsState } from "./types";
import { initialState } from "./state";

export const setLoading = (state: NotificationsState) => () => startRequest(state);

export const setLoaded = (state: NotificationsState) => () => finishRequest(state);

export const onGetNotificationsSuccess = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  individuals: {
    ...state.individuals,
    recipient: payload,
  },
});

export const onGetNotificationsError = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetMyEmployeeNotificationsSuccess = (state: NotificationsState) => ({
  payload,
}: *) => {
  return {
    ...state,
    individuals: {
      ...state.individuals,
      recipient: payload,
    },
  };
};

export const onGetHierarchyNotificationsSuccess = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  departments: {
    ...state.departments,
    recipient: payload,
  },
});

export const onGetHierarchyNotificationsError = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetNotificationsTargetsSuccess = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  individuals: {
    ...state.individuals,
    target: payload,
  },
});

export const onGetNotificationsTargetsError = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetHierarchyNotificationsTargetsSuccess = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  departments: {
    ...state.departments,
    target: payload,
  },
});

export const onGetHierarchyNotificationsTargetsError = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetNotificationsSummarySuccess = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  summary: payload,
});

export const onGetNotificationsSummaryError = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetNotificationsTargetsSummarySuccess = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  summary: payload,
});

export const onGetNotificationsTargetsSummaryError = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onToggleAddNotificationModal = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  modals: {
    ...state.modals,
    addNotification: {
      visible: payload,
      editing: false,
      data: {
        employeeDetails: null,
        notificationDates: {
          activeFrom: null,
          activeTo: null,
        },
      },
      list: initialState.modals.addNotification.list,
    },
  },
});

export const onToggleEditNotificationModal = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  modals: {
    ...state.modals,
    addNotification: {
      visible: payload.visible,
      editing: true,
      data: payload.data || {
        employeeDetails: null,
        notificationDates: {
          activeFrom: null,
          activeTo: null,
        },
      },
      list: initialState.modals.addNotification.list,
    },
  },
});

export const onGetAddNotificationModalEmployeeListSuccess = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  modals: {
    ...state.modals,
    addNotification: {
      ...state.modals.addNotification,
      list: payload,
    },
  },
});

export const onGetAddNotificationModalEmployeeListError = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetNotificationSchemaSuccess = (state: NotificationsState) => ({ payload }: *) => ({
  ...finishRequest(state),
  notificationSchema: payload,
});

export const onGetNotificationSchemaError = (state: NotificationsState) => ({ payload }: *) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
});

export const onGetIndividualsRevisionHistorySuccess = (state: NotificationsState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    modals: {
      ...state.modals,
      individualsRevisionHistory: {
        ...state.modals.individualsRevisionHistory,
        data: payload,
      },
    },
  };
};

export const onGetIndividualsRevisionHistoryError = (state: NotificationsState) => ({
  payload,
}: *) => ({
  ...finishRequest(state),
  error: payload,
});

export const onToggleIndividualsRevisionHistoryModal = (state: NotificationsState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      individualsRevisionHistory: {
        ...state.modals.individualsRevisionHistory,
        visible: !state.modals.individualsRevisionHistory.visible,
      },
    },
  };
};
export const onSearchNotificationAuditByStatusSuccess = (state: NotificationsState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    ...state,
    notificationAudit: {
      ...state.notificationAudit,
      list: payload,
    },
  };
};
